module.exports = __webpack_public_path__ + "img/img61.12f6f8b7.png";